import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { comics, categories } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.id === slug);
  const categoryComics = comics.filter((c) => c.category === slug);

  if (!category) {
    return (
      <Layout>
        <div className="flex flex-col items-center justify-center py-20">
          <p className="text-lg text-foreground-500">分类不存在</p>
          <Link to="/" className="text-accent-500 mt-2 hover:underline">返回首页</Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '分类', href: '/category/love' },
          { label: category.name },
        ]}
      />

      <section className="bg-foreground-900 py-16 md:py-20">
        <div className="px-4 md:px-6 lg:px-10">
          <div className="flex items-start gap-6">
            <span className="whitespace-nowrap cursor-pointer border border-background-50/30 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium">
              分类导航
            </span>
            <div>
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50">
                {category.name}韩漫
              </h1>
              <p className="text-sm text-foreground-400 mt-2">{category.description}，共 {category.count} 部作品</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-10">
        <div className="px-4 md:px-6 lg:px-10">
          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`whitespace-nowrap cursor-pointer px-4 py-1.5 rounded-full text-xs font-medium transition-colors ${
                  cat.id === slug
                    ? 'bg-foreground-900 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {categoryComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group"
              >
                <div className="bg-background-100 rounded-lg overflow-hidden">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      title={`${comic.title} - ${category.name}韩漫`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <p className="text-sm font-medium text-foreground-900 group-hover:text-accent-500 transition-colors line-clamp-1">
                    {comic.title}
                  </p>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs text-foreground-400">{comic.author}</span>
                    <span className="text-xs font-bold text-foreground-700">{comic.rating}</span>
                  </div>
                  <span className={`inline-block text-xs px-2 py-0.5 rounded-full mt-2 ${
                    comic.status === 'ongoing'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.statusText}
                  </span>
                </div>
              </Link>
            ))}
          </div>

          {categoryComics.length === 0 && (
            <div className="text-center py-16">
              <p className="text-foreground-400">该分类暂无漫画，敬请期待更多内容上线</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}